export default __webpack_public_path__ + "static/media/bg_green_wing_v03_crop.723ed3e1.png";